import { Product, Term, GalleryImage } from "@/types/product"

function getProductProperties(productData: Product, selectionData: Record<string, Term | null>): Record<string, string | number> {

    const result = getProductSelections(selectionData)
    result.wc_id = productData.id
    result.name = productData.name
    result.imageUrl = getProductImage(productData.gallery, result) || productData.image
    result.url = `${process.env.VUE_APP_WEB_URL}/product/${productData.slug}`
    
    return result
}

function getProductSelections(selectionData: Record<string, Term | null>) {
    const result= {} as Record<string, string | number>
    Object.entries(selectionData).map(attr => {
        const name = attr[0].replaceAll('-','_')
        const term = (attr[1] as Term)
        if(term) {
            if(name == 'stile') {
                result['stile'] = term.slug
                result['stile_text'] = term.name
                result['custom_stile_value'] = parseFloat(term.slug)
                result['custom_stile_id'] = term.id
            } else if(name == 'door_type') {
                result['door_type'] = term.slug
                result['door_type_text'] = term.name
            } else if(name == 'series') {
                result['series'] = term.id
                result['series_text'] = term.name
                result['series_note'] = term.description || ''
            } else {
                result[name] = term.id
                result[name + '_text'] = term.name
            }
            // Id: 999999 denotes custom width or height
            if(term.id === 999999) {
                result['custom_' + name] = parseFloat(term.slug)
                result['custom_' + name + '_text'] = term.name
            }
        }
    })

    return result
}

export function getProductImage(gallery: GalleryImage[],properties: Record<string, string | number>): string | null {
    if(gallery) {
        for (const image of gallery) {
            const constraints = image.alt.split(';')
            let conditionsMet = true
    
            if (constraints.length == 0) conditionsMet = false
    
            for (const param of constraints) {
                const keyValue = param.split(':')
                const key = keyValue[0]
                const value = keyValue[1]
                if (key && value) {
                    const range = value.split('-')
                    const propValue = parseInt((properties[`${key}_text`] as string).replace('"', ''))
                    if (range.length === 1) {
                        if (!(parseInt(range[0]) === propValue)) {
                            conditionsMet = false
                        }
                    } else {
                        if (!(parseInt(range[0]) <= propValue && propValue <= parseInt(range[1]))) {
                            conditionsMet = false
                        }
                    }
                } else {
                    conditionsMet = false
                }
            }
    
            if (conditionsMet) {
                return image.src
            }
        }
    }

    // Grab the first image
    return null
}

export default getProductProperties